import React from 'react'
import ParcelsPage from '../containers/Parcels/Parcels'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers' 
 
const Parcels = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <ParcelsPage/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Parcels
